import styled from '@emotion/styled';
import { Chip } from 'src/components/atoms';

interface Props {
  category: string;
}

const StyledMymeCategory = styled(Chip)(
  ({ theme }) => `
    max-width: min-content;
    height: min-content;
    background-color: ${theme.palette.primary.main};
    border-radius: 0.5rem;
    font-size: 12px;

    span {
        padding: 3px 5px;
        text-transform: uppercase;
    }
  `
);

export const MymeCategory = ({ category }: Props) => {
  return <StyledMymeCategory label={category} />;
};
